"use strict";

exports.__esModule = true;
exports.TimeFormatSelector = TimeFormatSelector;
var _react = _interopRequireDefault(require("react"));
var _Selector = require("../../Core/Selector");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var defaultFormats = [{
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}, {
  hour: "2-digit",
  minute: "2-digit"
}, {
  hour11: true,
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}, {
  hour11: true,
  hour: "2-digit",
  minute: "2-digit"
}];
function getKey(input) {
  return JSON.stringify(input);
}
function renderItemText(input) {
  var locales = input != null && input.hasOwnProperty("hour11") ? "en-US" : undefined;
  return new Date().toLocaleTimeString(locales, input);
}

/**
 * Allows a user to select shift(s) from a list.
 */
function TimeFormatSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      placeholder: props.multiple ? translate("TimeFormatSelector.placeholder.multiple", "Select Time Formats") : translate("TimeFormatSelector.placeholder.single", "Select Time Format"),
      getKey: getKey,
      renderItemText: renderItemText,
      filterable: false,
      items: defaultFormats
    }, props));
  });
}